import React from 'react';
import { TypographyBody, Notification, WarningIcon } from '@honeycomb/ui-core';
import { useGlobalContext } from '@honeycomb/data';
export function HotelRoomsError() {
    const { resourceStrings: { HOTEL_ROOM_ERROR_HEADING, HOTEL_ROOM_ERROR_SUB_HEADING }, } = useGlobalContext();
    return (React.createElement(Notification, { color: "error", icon: React.createElement(WarningIcon, null) },
        React.createElement(TypographyBody, { weight: "bold" }, HOTEL_ROOM_ERROR_HEADING),
        HOTEL_ROOM_ERROR_SUB_HEADING));
}
